// Feature route registry.
//
// Each feature folder may export from `features/<name>/routes.tsx`:
//   - `routes`:           admin routes rendered inside the AppShell (authenticated)
//   - `fullscreenRoutes`: authenticated routes rendered without the AppShell (e.g. POS)
//   - `publicRoutes`:     unauthenticated routes (e.g. public invoice views)
// Paths are relative to the router basename (no leading slash).
// Feature routes are registered before the built-in ones, so a feature can
// replace an existing page by exporting the same path.

import type { ReactNode } from 'react';

export type FeatureRoute = { path: string; element: ReactNode };

type FeatureModule = {
  routes?: FeatureRoute[];
  fullscreenRoutes?: FeatureRoute[];
  publicRoutes?: FeatureRoute[];
};

const modules = import.meta.glob<FeatureModule>('./*/routes.tsx', { eager: true });

function collect(key: keyof FeatureModule): FeatureRoute[] {
  return Object.keys(modules)
    .sort()
    .flatMap((path) => modules[path][key] ?? []);
}

export const featureRoutes = collect('routes');
export const featureFullscreenRoutes = collect('fullscreenRoutes');
export const featurePublicRoutes = collect('publicRoutes');
